import React, { Fragment } from 'react';
import { formatProducts, getSalesSummary } from '../utils';
export default function PrintUserId({ orders, user, dates }) {
    return (
        <Fragment >
            <div className="no-visible-screen" style={{ marginLeft: '2%', marginTop: '16px' }}>
                <p style={{ margin: 0, padding: 0 }}>Repartidor: <strong>{user.name}</strong></p>
                <p style={{ margin: 0, padding: 0 }}>Fecha: <strong>{dates.startDate} - {dates.endDate}</strong></p>
            </div>
            <table className="print-table no-visible-screen">

                <thead>
                    <tr>
                        <th className="col-id">ID</th>
                        <th className="col-cliente">Cliente</th>
                        <th className="col-productos">Productos</th>
                        <th className="col-pago">Forma de pago</th>
                        <th className="col-observacion">Observación</th>
                    </tr>
                </thead>

                <tbody>
                    {orders.map(order => (
                        <tr key={order.id}>
                            <td style={{ fontSize: 14 }}>{order.id}<br />{order.requestedFrom}</td>
                            <td style={{ fontSize: 13 }}>{order.cliente}<br />{order.direccion.substring(0, 50)}</td>
                            <td style={{ fontSize: 16 }}>{order.cantidad}</td>
                            <td style={{ fontSize: 14 }}>{!order.subscription ? (
                                order.paymentMethod.name.split('(')[0]
                            ) : (
                                <div style={{ color: 'black', margin: 0, padding: 0 }}>
                                    <strong>Recargas a favor</strong>
                                </div>
                            )}{order.payment_confirmation_id && (
                                <div style={{ color: 'black', margin: 0, padding: 0 }}>
                                    <strong>({order.payment_confirmation_id})</strong>
                                </div>
                            )}</td>
                            <td style={{ fontSize: 15 }}>{order.observation}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </Fragment>
    )
}